import { render, staticRenderFns } from "./documentAdmin.vue?vue&type=template&id=8cfccfec&"
import script from "./documentAdmin.vue?vue&type=script&lang=js&"
export * from "./documentAdmin.vue?vue&type=script&lang=js&"
import style0 from "./documentAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports